import { useMemo } from 'react';

import { Stepper } from '../../../../components/Stepper';
import FirstStepWizard from './FirstStepWizard';
import SecondStepWizard from './SecondStepWizard';
import { PhoneTable } from './PhoneTable';
import ThirdStepWizard from './ThirdStepWizard';
import { useTaskWizard } from '../hooks/useTaskWizard';
import { Breadcrumbs, Button, Form, Spinner } from '../../../../components';
import type { Row } from '../../../../components/FileReader';

export type FormProps = {
  taskName: string;
  language: string;
  callAgentName: string;
  agentCallInstruction: string;
  file: Row[] | null;
  maxCallDuration: number | string;
  engageConversation: boolean;
  leaveVoiceMail: boolean;
  keepTryingReachPerson: boolean;
  retriesNumber: number | string;
  retryInterval: number | string;
  timezone: string;
  taskDate: string;
  startTime: string;
  endTime: string;
  outboundPhoneNumber: string;
};

const CallTaskWizardPage = () => {
  const {
    formData,
    handleFormChange,
    saveAsDraft,
    saveAsTask,
    formId,
    currentStep,
    setCurrentStep,
    isLoading,
  } = useTaskWizard();

  const steps = [
    {
      label: 'Choose Agent',
      content: <FirstStepWizard values={formData} />,
    },
    {
      label: 'Import Contacts',
      content: <SecondStepWizard values={formData} />,
    },
    {
      label: 'Batch Caller Task Configuration',
      content: <ThirdStepWizard values={formData} />,
    },
  ];

  const handleComplete = () => {
    saveAsTask();
  };

  const isSecondStep = useMemo(
    () => formData?.file?.length && currentStep === 1,
    [currentStep, formData?.file?.length]
  );

  const handleSaveDraft = () => {
    saveAsDraft();
  };

  if (isLoading) return <Spinner size={40} />;

  return (
    <div className="w-full h-[calc(100vh-84px)]  max-h- flex flex-col overflow-hidden">
      <div className="flex flex-col w-full">
        <Breadcrumbs
          className="mb-xs text-small"
          items={[
            { label: 'Mass Outreach Tasks', url: '/batch_calls' },
            { label: 'Create Task', url: '' },
          ]}
        />
        <h1 className="text-section font-semibold">Create Task</h1>
      </div>
      <div className="flex flex-wrap justify-end items-center mb-2">
        <Button label="Save Draft" onClick={handleSaveDraft} size="medium" />
      </div>
      <div className="border-t border-border w-full h-[calc(100%-84px)] border-1 mt-2 flex flex-col ">
        <div
          className={`flex flex-col overflow-y-auto ${isSecondStep ? 'h-3/4' : 'h-full'}`}
        >
          {isLoading ? (
            <div className="flex items-center justify-center h-full">
              <Spinner size={40} />
            </div>
          ) : (
            <Form
              onChange={handleFormChange}
              initialValue={formData}
              key={formId}
            >
              <Stepper
                steps={steps}
                currentStep={currentStep}
                onComplete={() => handleComplete()}
                onStepChange={setCurrentStep}
              />
            </Form>
          )}
        </div>
        {isSecondStep ? (
          <div className="min-h-[300px] h-1/4 overflow-y-auto border-t border-border pb-10">
            <PhoneTable rows={formData.file} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CallTaskWizardPage;
